module.exports = __webpack_public_path__ + "static/media/n1.cea402f0.jpg";